export enum ArticleContentBlockTypes {
  ArticleBanner = 'ArticleBanner',
  Code = 'Code',
  CTAButton = 'CTAButton',
  Highlight = 'Highlight',
  Image = 'Image',
  Quote = 'Quote',
  RawHTML = 'RawHTML',
  Table = 'Table',
  TextBlock = 'TextBlock',
  Video = 'Video',
}

type ArticleBanner = {
  type: ArticleContentBlockTypes.ArticleBanner;
};

type CodeBlock = {
  type: ArticleContentBlockTypes.Code;
  code?: string;
};

type CTAButton = {
  type: ArticleContentBlockTypes.CTAButton;
  title?: string;
  link?: string;
};

type HighlightBlock = {
  type: ArticleContentBlockTypes.Highlight;
  richText?: string;
};

type ImageBlock = {
  type: ArticleContentBlockTypes.Image;
  src?: string;
  alt?: string;
  description?: string;
};

type QuoteBlock = {
  type: ArticleContentBlockTypes.Quote;
  text?: string;
  author?: string;
  post?: string;
};

type RawHTML = {
  type: ArticleContentBlockTypes.RawHTML;
  html?: string;
};

type Table = {
  type: ArticleContentBlockTypes.Table;
  rows?: string[][];
};

export type TextBlock = {
  type: ArticleContentBlockTypes.TextBlock;
  id?: string;
  title?: string;
  richText?: string;
};

type VideoBlock = {
  type: ArticleContentBlockTypes.Video;
  link?: string;
  previewImage?: string;
};

type ArticleContentBlock =
  | ArticleBanner
  | CodeBlock
  | CTAButton
  | HighlightBlock
  | ImageBlock
  | QuoteBlock
  | RawHTML
  | Table
  | TextBlock
  | VideoBlock;

export interface ArticleContent {
  blocks: ArticleContentBlock[];
}
